module.exports = __webpack_public_path__ + "img/sdp.0b2b833a.jpg";